// src/Views/PortfolioPage.js
import React from 'react';
import PortfolioGallery from './PortfolioGallery';
import { MAX_CONTENT_WIDTH, SPACING_CARD, SPACING_HERO, SPACING_PAGE, SPACING_PAGE_LARGE } from '../constants/layout';
import {
  FONT_TITLE,
  FONT_TITLE_MOBILE,
  FONT_BODY,
} from '../constants/typography';

export default function PortfolioPage() {
  return (
    <div className="portfolio-page">
      <section className="portfolio-section">
        <div className="container">
          <h1 className="page-heading">Our Work</h1>
          <p className="page-description">
            See our work on laminate, marble, travertine, VCT, and other types of flooring!
          </p>
          <PortfolioGallery />
        </div>
      </section>

      <style jsx>{`
        .portfolio-page {
          width: 100%;
        }

        .container {
          max-width: ${MAX_CONTENT_WIDTH};
          margin: 0 auto;
          padding: 0 ${SPACING_CARD};
        }

        .portfolio-section {
          padding: ${SPACING_PAGE_LARGE} ${SPACING_CARD};
          padding-left: max(16px, env(safe-area-inset-left));
          padding-right: max(16px, env(safe-area-inset-right));
        }

        .page-heading {
          font-size: ${FONT_TITLE};
          font-weight: 700;
          color: var(--color-text-primary);
          margin: 0 0 ${SPACING_CARD} 0;
          text-align: center;
          letter-spacing: 0;
        }

        .page-description {
          font-size: ${FONT_BODY};
          color: var(--color-text-secondary);
          text-align: center;
          margin: 0 0 ${SPACING_HERO} 0;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        }

        @media (max-width: 768px) {
          .portfolio-section {
            padding: ${SPACING_PAGE} ${SPACING_CARD};
            padding-left: max(16px, env(safe-area-inset-left));
            padding-right: max(16px, env(safe-area-inset-right));
          }

          .page-heading {
            font-size: ${FONT_TITLE_MOBILE};
          }
        }
      `}</style>
    </div>
  );
}
